/*
 *
 * Do not edit directly
 * Generated on Thu, 24 Apr 2025 18:51:19 GMT
 *
 */

import PaletteIconQuoteLeft from '@telus-uds/palette-allium/build/rn/icons/QuoteLeft'
import PaletteIconQuoteLeftArrow from '@telus-uds/palette-allium/build/rn/icons/QuoteLeftArrow'
const theme = {
  appearances: {
    viewport: {
      description: 'The size label for the current screen viewport based on the current screen width',
      type: 'state',
      values: [ 'xs', 'sm', 'md', 'lg', 'xl' ]
    }
  },
  rules: [
    {
      if: { viewport: [ 'md', 'lg', 'xl' ] },
      tokens: {
        testimonialFontNameHeading: 'HNforTELUSSA',
        testimonialFontSizeHeading: 28,
        testimonialFontWeightHeading: '400',
        testimonialLineHeightHeading: 1.28571428571
      }
    }
  ],
  tokens: {
    additionalFontName: 'HNforTELUSSA',
    additionalFontSize: 14,
    additionalFontWeight: '400',
    additionalLineHeight: 1.42857142857,
    authorFontName: 'HNforTELUSSA',
    authorFontSize: 16,
    authorFontWeight: '700',
    authorLineHeight: 1.5,
    dividerBackgroundColor: '#b2b9bf',
    dividerBorder: 1,
    figcaptionGap: 12,
    icon: PaletteIconQuoteLeft,
    iconColor: '#b2b9bf',
    iconFr: PaletteIconQuoteLeftArrow,
    imageSize: 48,
    quoteContainerGap: 4,
    testimonialContainerGap: 12,
    testimonialFontNameHeading: 'HNforTELUSSA',
    testimonialFontNameLarge: 'HNforTELUSSA',
    testimonialFontSizeHeading: 24,
    testimonialFontSizeLarge: 20,
    testimonialFontWeightHeading: '400',
    testimonialFontWeightLarge: '400',
    testimonialLineHeightHeading: 1.33333333333,
    testimonialLineHeightLarge: 1.6,
    textColor: '#414547'
  }
}
export default theme
